class App {
  constructor() {
    this._appName = "";
    this._appTotal = 0;
    this._aiApp = "";
    this._ctaLink = "";
  }

  get appName() {
    return this._appName;
  }

  get appTotal() {
    return this._appTotal;
  }

  get aiApp() {
    return this._aiApp;
  }

  set appName(value) {
    this._appName = value;
  }

  set appTotal(value) {
    this._appTotal = value;
  }

  set aiApp(value) {
    this._aiApp = value;
  }
}
const app = new App();

module.exports = app;